var _path, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDeliveredIcon = function SvgDeliveredIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1200_64",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 61,
    height: 61
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.8334 59.6669V1H1.16656V59.6669H59.8334Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1200_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5 30.3334L23.3906 40.9975H1.35147L8.46087 30.3334H30.5Z",
    stroke: "#CDD5DF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46086 40.9974V59.4818H52.5391V40.9974",
    stroke: "#CDD5DF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 59.4818V30.3333",
    stroke: "#CDD5DF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3906 18.9584C17.0656 13.6879 12.7265 10.9247 12.7265 6.75034C12.7265 3.7324 14.902 1.18487 18.0586 1.18487C22.1109 1.18487 23.3906 5.62824 23.3906 5.62824C23.3906 5.62824 24.6703 1.18487 28.7226 1.18487C31.8792 1.18487 34.0547 3.7324 34.0547 6.75034C34.0547 10.9247 29.7156 13.6879 23.3906 18.9584Z",
    stroke: "#CDD5DF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7188 13.1819C44.7188 13.1819 45.5719 10.0715 48.2735 10.0715C50.3779 10.0715 51.8282 11.8548 51.8282 13.9675C51.8282 16.8894 48.9347 18.8232 44.7188 22.513C40.5029 18.8232 37.6094 16.8894 37.6094 13.9675C37.6094 11.8548 39.0597 10.0715 41.1641 10.0715C43.8657 10.0715 44.7188 13.1819 44.7188 13.1819Z",
    stroke: "#CDD5DF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5196 30.3334C42.5196 30.435 42.6029 30.5183 42.7045 30.5183C42.806 30.5183 42.8894 30.435 42.8894 30.3334C42.8894 30.2319 42.806 30.1485 42.7045 30.1485C42.6029 30.1485 42.5196 30.2319 42.5196 30.3334Z",
    fill: "#CDD5DF",
    stroke: "#CDD5DF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3724 30.3334H30.5L37.6094 40.9975H59.6485L52.5391 30.3334H48.0365",
    stroke: "#CDD5DF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeliveredIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delivered-icon.fe0ac484.svg";
export { ForwardRef as ReactComponent };